import { FC, MouseEventHandler, ReactNode } from 'react';
import * as React from 'react';

import { Box } from '@mui/material';

import { ReactComponent as DropdownArrow } from 'assets/icons/DropdownArrow.svg';

import { Button } from 'components/_basic/Button/Button';
import { Responsive } from 'components/_basic/Responsive';

import styles from './SelectorMenuToggleButton.module.scss';

export interface ISelectorMenuToggleButtonProps {
  onClick: MouseEventHandler;
  icon: ReactNode;
  isLoading: boolean;
  label?: string;
}

export const SelectorMenuToggleButton: FC<ISelectorMenuToggleButtonProps> = ({
  onClick,
  icon,
  label,
  isLoading
}) => (
  <Button
    className={styles.buttonWrapper}
    buttonClassName={styles.templateSelect}
    onClick={onClick}
    isLoading={isLoading}
  >
    <Box className={styles.icon}>{icon}</Box>
    <Responsive aboveMobile>
      <Box>{label}</Box>
    </Responsive>
    <DropdownArrow />
  </Button>
);
